import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// import 'amfe-flexible'
import store from "./store";
import $dayjs from "dayjs";

Vue.config.productionTip = false
Vue.use(ElementUI)
Vue.prototype.$dayjs =$dayjs
new Vue({
  router,  // 正确注入
  store,
  render: h => h(App),
}).$mount('#app')


